"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.objToClearJSON = exports.argEnum = exports.argDate = exports.argBool = exports.argString = exports.argFloat = exports.argInt = exports.argSearch = exports.enumCast = exports.date = exports.bool = exports.string = exports.float = exports.int = void 0;
/** Cast argument to integer or return default */
function int(arg, def = 0) { if (!arg)
    return def; return parseInt(arg); }
exports.int = int;
/** Cast argument to float or return default */
function float(arg, def = 0.0) { if (!arg)
    return def; return parseFloat(arg); }
exports.float = float;
/** Cast argument to string or return default */
function string(arg, def = '') { if (!arg)
    return def; return arg.toString(); }
exports.string = string;
/** Cast argument to boolean or return default */
function bool(arg, def = false) { if (arg === undefined)
    return def; let a = arg.toString(); a = a.toLowerCase(); if (a === 'true' || a === '1' || a === 't')
    return true; return def; }
exports.bool = bool;
/** Cast argument to Date or return default */
function date(arg, def = new Date()) {
    if (!arg)
        return def;
    let date = new Date(arg);
    if (!date.getDate) {
        date = new Date();
        const dt = arg.split(' ');
        const d = dt[0].split('-');
        const t = dt[1].split(':');
        date.setFullYear(parseInt(d[0]));
        date.setMonth(parseInt(d[1]) - 1);
        date.setDate(parseInt(d[2]));
        date.setHours(parseInt(t[0]));
        date.setMinutes(parseInt(t[1]));
        date.setSeconds(parseInt(t[2]));
    }
    return date;
}
exports.date = date;
/** Cast argument to enum:T or return default */
function enumCast(enumType, arg, def) {
    if (typeof arg === 'number' && enumType[arg] !== undefined)
        return arg;
    if (typeof arg === 'string') {
        if (arg in enumType) {
            const result = enumType[arg];
            if (typeof result === 'number' || typeof result === 'string')
                return result;
        }
        const parsedNum = parseInt(arg, 10);
        if (!isNaN(parsedNum) && enumType[parsedNum] !== undefined)
            return parsedNum;
    }
    return def;
}
exports.enumCast = enumCast;
/** Trying found arg of object in various cases */
function argSearch(name, obj) {
    if (obj[name])
        return obj[name];
    const nameCap = name.charAt(0).toUpperCase() + name.slice(1);
    if (obj[nameCap])
        return obj[nameCap];
    const nameLow = name.toLowerCase();
    if (obj[nameLow])
        return obj[nameLow];
    return undefined;
}
exports.argSearch = argSearch;
/** Search and cast object argument to integer */
function argInt(name, obj, def = 0) { const arg = argSearch(name, obj); return int(arg, def); }
exports.argInt = argInt;
/** Search and cast object argument to float */
function argFloat(name, obj, def = 0.0) { const arg = argSearch(name, obj); return float(arg, def); }
exports.argFloat = argFloat;
/** Search and cast object argument to string */
function argString(name, obj, def = '') { const arg = argSearch(name, obj); return string(arg, def); }
exports.argString = argString;
/** Search and cast object argument to string */
function argBool(name, obj, def = false) { const arg = argSearch(name, obj); return bool(arg, def); }
exports.argBool = argBool;
/** Search and cast object argument to string */
function argDate(name, obj, def = new Date()) { const arg = argSearch(name, obj); return date(arg, def); }
exports.argDate = argDate;
/** Search and cast object argument to string */
function argEnum(name, obj, enumType, def) {
    const arg = argSearch(name, obj);
    return enumCast(enumType, arg, def);
}
exports.argEnum = argEnum;
/** Clear object for data model */
function objToClearJSON(obj) {
    function clearObj(o) {
        let cl = {};
        if (Array.isArray(o))
            cl = [];
        const needClear = (typeof o !== "string") &&
            (typeof o !== "number") &&
            (typeof o !== "boolean") &&
            (!(o instanceof Date));
        if (needClear)
            for (const attr in o) {
                if (attr.indexOf('_') === 0)
                    continue;
                cl[attr] = clearObj(o[attr]);
            }
        if (needClear)
            return cl;
        else
            return o;
    }
    return JSON.stringify(clearObj(obj));
}
exports.objToClearJSON = objToClearJSON;
//# sourceMappingURL=def.js.map